// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.empty-message {
  display: inherit;
  transform: translate(-50%, -50%);
  position: absolute;
  top: 50%;
  left: 50%;
  font-weight: bold;
  font-size: 12px;
  color: #a9a9a9;
  white-space: pre;
}


.tooltip-label {
  font-weight: bold;
}
.tooltip-value {
  margin-left: 5px;
}
.tooltip-name {
  font-weight: bold;
}

.tooltip {
  font: 12px/1.5 "Helvetica Neue", Arial, Helvetica, sans-serif;
  position: absolute;
  transform: translate(-50%, -100%);
  z-index: 999;
  background: white;
  border-radius: 6px;
  color: #333;
  box-shadow: 0 3px 14px rgb(0 0 0 / 40%);
}
.tooltip-content {
  min-width: 110px;
  width: max-content;
  white-space: nowrap;
  margin: 13px 19px;
    line-height: 1.4;
}
/* near the top of the map the tooltip is shown below the marker, tip pointing up */
.tooltip.below {
  transform: translate(-50%, 0);
}
.tooltip.below .tooltip-tip-container {
  top: -20px;
  transform: scaleY(-1);
}

.tooltip-tip-container {
    width: 40px;
    height: 20px;
    position: absolute;
    left: 50%;
    margin-left: -20px;
    overflow: hidden;
    pointer-events: none;
}
.tooltip-tip {
  background: white;
  width: 17px;
  height: 17px;
  padding: 1px;
  margin: -10px auto 0;
  transform: rotate(45deg);
}

.messurements {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
}
.sensor-map {
  position: relative;
}
.sensors {
  display: flex; justify-content: space-around; margin: 10px;
}
.sensor-item {
  background: none;
  color: white;
  font-size: 14px;
  font-weight: bold;

  border-radius: 2px;
  white-space: pre;
  padding: 3px;
  position: absolute;
  
}

.error-value {
  color: #d53d0e;
}

.sensor-item-shape {
  width: 20px;
  height: 20px;
  background: red;
  display: block;
  border-radius: 45px;
  background: url("/assets/svg/spear_sensor.svg");
}
.sensor {
  border: 1px solid transparent;
}
.sensor.active {
  border-bottom: 2px solid;
}
.selected {
  outline: 1px solid gray;

}
.invalid {
  opacity: 0.5;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/farmer-building/farmer-building.ts"],"names":[],"mappings":";;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;;AAGA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,6DAA6D;EAC7D,kBAAkB;EAClB,iCAAiC;EACjC,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,uCAAuC;AACzC;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;IACf,gBAAgB;AACpB;AACA,mFAAmF;AACnF;EACE,6BAA6B;AAC/B;AACA;EACE,UAAU;EACV,qBAAqB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;AACxB;AACA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa,EAAE,6BAA6B,EAAE,YAAY;AAC5D;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,iBAAiB;;EAEjB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;;AAEpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,+CAA+C;AACjD;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,uBAAuB;;AAEzB;AACA;EACE,YAAY;AACd","sourcesContent":["\n\n.empty-message {\n  display: inherit;\n  transform: translate(-50%, -50%);\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  font-weight: bold;\n  font-size: 12px;\n  color: #a9a9a9;\n  white-space: pre;\n}\n\n\n.tooltip-label {\n  font-weight: bold;\n}\n.tooltip-value {\n  margin-left: 5px;\n}\n.tooltip-name {\n  font-weight: bold;\n}\n\n.tooltip {\n  font: 12px/1.5 \"Helvetica Neue\", Arial, Helvetica, sans-serif;\n  position: absolute;\n  transform: translate(-50%, -100%);\n  z-index: 999;\n  background: white;\n  border-radius: 6px;\n  color: #333;\n  box-shadow: 0 3px 14px rgb(0 0 0 / 40%);\n}\n.tooltip-content {\n  min-width: 110px;\n  width: max-content;\n  white-space: nowrap;\n  margin: 13px 19px;\n    line-height: 1.4;\n}\n/* near the top of the map the tooltip is shown below the marker, tip pointing up */\n.tooltip.below {\n  transform: translate(-50%, 0);\n}\n.tooltip.below .tooltip-tip-container {\n  top: -20px;\n  transform: scaleY(-1);\n}\n\n.tooltip-tip-container {\n    width: 40px;\n    height: 20px;\n    position: absolute;\n    left: 50%;\n    margin-left: -20px;\n    overflow: hidden;\n    pointer-events: none;\n}\n.tooltip-tip {\n  background: white;\n  width: 17px;\n  height: 17px;\n  padding: 1px;\n  margin: -10px auto 0;\n  transform: rotate(45deg);\n}\n\n.messurements {\n  display: flex;\n  justify-content: space-between;\n  font-size: 14px;\n}\n.sensor-map {\n  position: relative;\n}\n.sensors {\n  display: flex; justify-content: space-around; margin: 10px;\n}\n.sensor-item {\n  background: none;\n  color: white;\n  font-size: 14px;\n  font-weight: bold;\n\n  border-radius: 2px;\n  white-space: pre;\n  padding: 3px;\n  position: absolute;\n  \n}\n\n.error-value {\n  color: #d53d0e;\n}\n\n.sensor-item-shape {\n  width: 20px;\n  height: 20px;\n  background: red;\n  display: block;\n  border-radius: 45px;\n  background: url(\"/assets/svg/spear_sensor.svg\");\n}\n.sensor {\n  border: 1px solid transparent;\n}\n.sensor.active {\n  border-bottom: 2px solid;\n}\n.selected {\n  outline: 1px solid gray;\n\n}\n.invalid {\n  opacity: 0.5;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
